function mysqlToReal(value) {
    return value.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).replace('.', ',');
}

function realToMysql(value) {
    if (!value) return 0;

    return parseFloat(value.replace('R$', '').replace(/\./g, '').replace(',', '.').trim()) || 0;
}

function formatCurrency(value) {
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export { mysqlToReal, realToMysql, formatCurrency };